import { render, staticRenderFns } from "./StagingBanner.vue?vue&type=template&id=6a4117b9&scoped=true&"
import script from "./StagingBanner.vue?vue&type=script&lang=ts&"
export * from "./StagingBanner.vue?vue&type=script&lang=ts&"
import style0 from "./StagingBanner.vue?vue&type=style&index=0&id=6a4117b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4117b9",
  null
  
)

export default component.exports